import React from 'react';
import { GiftIcon, TimerIcon } from 'lucide-react';
import { useCountdown } from '../contexts/CountdownContext';
export function AnnouncementBar() {
  const {
    label
  } = useCountdown();
  return <div className="sticky top-0 z-40 w-full bg-teal text-white" data-id="element-19" data-mp="jtk1t94iugih">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-3 px-4 py-2.5 text-sm font-bold md:gap-5" data-id="element-20" data-mp="jrqtzqi69q8w">
        <span className="hidden items-center gap-2 sm:inline-flex" data-id="element-21" data-mp="9vnvqvqfybr8">
          <GiftIcon className="h-4 w-4 text-sun" aria-hidden data-id="element-22" data-mp="9tt99cziubl1" />
          Last hours: <span className="text-sun" data-id="element-23" data-mp="5sr64l2hhfds">50% OFF</span> + 3 free bonus gifts
        </span>
        <span className="sm:hidden" data-id="element-24" data-mp="wahlprdgz06">
          <span className="text-sun" data-id="element-25" data-mp="xbwy6ff87np">50% OFF</span> + 3 free bonuses
        </span>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1 font-display tabular-nums text-teal" data-id="element-26" data-mp="3s33lx2hgpe8x">
          <TimerIcon className="h-4 w-4" aria-hidden data-id="element-27" data-mp="1v6w8rsvkvf8v" />
          {label}
        </span>
      </div>
    </div>;
}